module.exports = __webpack_public_path__ + "img/pic_empty_jurisdiction@2x.4c938754.png";